//types
export const SAVE_HANDLE_INIT = 'API/SAVE/HANDLE/INIT';
export const SAVE_HANDLE_VISIBLE = 'API/SAVE/HANDLE/VISIBLE';
export const SAVE_HANDLE_TARGET_NAME = 'API/SAVE/HANDLE/TARGET_NAME';

export const setHandleInit = () => ({ type: SAVE_HANDLE_INIT });
export const setHandleVisible = (visible) => ({ type: SAVE_HANDLE_VISIBLE, visible });
export const setHandleTargetName = (name) => ({ type: SAVE_HANDLE_TARGET_NAME, name });